module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<form id="xFormRecaptcha" method="post">\n	<div id="recaptchaWrapper"></div>\n</form>\n';
}
return __p;
};
